import React from "react";

const Hamburger = (props) => {
  let HamburgerClasses = "hamburger hamburger--collapse";
  if (props.active) {
    HamburgerClasses = "hamburger hamburger--collapse is-active";
  }
  return (
    <button
      style={{
        background: "none",
        padding: 0,
        margin: "0 0 0 auto",
        outline: "none",
        height: "22px",
      }}
      onClick={props.clicked}
      className={HamburgerClasses}
      type="button"
    >
      <span className="hamburger-box">
        <span className="hamburger-inner"></span>
      </span>
    </button>
  );
};

export default Hamburger;
